import React from "react";
import {
    Box, TextField, MenuItem, InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

/**
 * Simple reusable toolbar (search + active filter).
 * Keep it lightweight to avoid large refactors.
 */
export default function ListToolbar({
    search,
    onSearch,
    activeFilter = "all", // all | active | inactive
    onActiveFilter,
    searchPlaceholder = "Rechercher…",
    sortValue = "",
    onSortChange,
    sortOptions = [],
    children,
}) {
    return (
        <Box
            display="flex"
            gap={1}
            flexWrap="wrap"
            alignItems="center"
            mb={2}
        >
            <TextField
                value={search}
                onChange={(e) => onSearch(e.target.value)}
                size="small"
                placeholder={searchPlaceholder}
                sx={{ minWidth: 260, flex: 1, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
                        </InputAdornment>
                    ),
                }}
            />
            {typeof onActiveFilter === "function" && (
                <TextField
                    select
                    size="small"
                    label="Statut"
                    value={activeFilter}
                    onChange={(e) => onActiveFilter(e.target.value)}
                    sx={{ minWidth: 170, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                >
                    <MenuItem value="all">Tous</MenuItem>
                    <MenuItem value="active">Actifs</MenuItem>
                    <MenuItem value="inactive">Inactifs</MenuItem>
                </TextField>
            )}
            {typeof onSortChange === "function" && Array.isArray(sortOptions) && sortOptions.length > 0 && (
                <TextField
                    select
                    size="small"
                    label="Tri"
                    value={sortValue}
                    onChange={(e) => onSortChange(e.target.value)}
                    sx={{ minWidth: 180, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                >
                    {sortOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                </TextField>
            )}
            {children}
        </Box>
    );
}

